<template>
  <div
    class="request-row-hover-actions"
    data-testid="request-row-hover-actions"
  >
    <div
      v-if="hasActions"
      class="request-row-hover-actions__bar"
    >
      <template v-for="action in primaryActions">
        <v-tooltip
          :key="action.id"
          top
          content-class="tooltip-top"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="request-row-hover-actions__btn"
              v-bind="attrs"
              v-on="on"
              :aria-label="action.label"
              :data-testid="`request-row-hover-actions__${action.id}`"
              @click.stop="$emit('action', { actionId: action.id, request })"
            >
              <img
                v-if="isAssetIcon(action.icon)"
                :src="action.icon"
                alt=""
                class="request-row-hover-actions__icon-img"
                width="16"
                height="16"
              >
              <v-icon
                v-else
                small
                class="request-row-hover-actions__icon"
              >
                {{ action.icon }}
              </v-icon>
            </button>
          </template>
          <span>{{ action.label }}</span>
        </v-tooltip>
      </template>

      <span
        v-if="primaryActions.length && overflowActions.length"
        class="request-row-hover-actions__divider"
        aria-hidden="true"
      />

      <RequestRowOverflowMenu
        v-if="overflowActions.length"
        :actions="overflowActions"
        :request="request"
        :is-open="overflowOpen"
        @toggle="$emit('overflow-toggle', $event)"
        @action="$emit('action', $event)"
      />
    </div>
  </div>
</template>

<script>
import './RequestRowHoverActions.scss';
import RequestRowOverflowMenu from './RequestRowOverflowMenu.vue';

export default {
  name: 'RequestRowHoverActions',
  components: {
    RequestRowOverflowMenu,
  },
  props: {
    request: {
      type: Object,
      default: () => ({}),
    },
    primaryActions: {
      type: Array,
      default: () => [],
    },
    overflowActions: {
      type: Array,
      default: () => [],
    },
    overflowOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActions() {
      return this.primaryActions.length > 0 || this.overflowActions.length > 0;
    },
  },
  methods: {
    isAssetIcon(icon) {
      return typeof icon === 'string' && (icon.startsWith('/') || icon.startsWith('http'));
    },
  },
};
</script>
